import React from 'react';
import './Order.css';


function Order() {
  const locations = {
    Broumanna: [
      {
        name: 'Toters',
        image: "/toterslogo.png",
        url: "https://dlct3.app.link/z0daGV1B5Wb"
      },
      {
        name: 'Whatsapp Delivery',
        image: "/whatsapplogo.png",
        url: 'https://wa.me/message/I4STMZVCMEQ6F1', // Replace with your Montreal DoorDash link
      },
    ],
    
  };

  return (
    <div className="order-online">
      <h1 className="order-online__title">Order Online</h1>
      <div className="order-online__locations">
        {Object.keys(locations).map((location) => (
          <div key={location} className="order-online__location">
            <h2 className="order-online__location-title">{location}</h2>
            <div className="order-online__grid">
              {locations[location].map((app, index) => (
                <a
                  href={app.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={index}
                  className="order-online__box"
                >
                  <img src={app.image} alt={`${app.name} Logo`} className="order-online__image" />
                  <p className="order-online__name">{app.name}</p>
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Order;